import * as Sentry from '@sentry/react';

import Console, { logLevels } from 'utility/Debug/Console';

import { dsn, ignoreErrors } from './config';
import { getCurrentRelease } from './helper/getCurrentRelease';
import { collectTagData } from './helper/getTagList';
import { browserProfiling } from './integrations/browserProfiling';
import {
    browserTracing,
    tracesSampleRate,
} from './integrations/browserTracing';
import {
    replay,
    replaysOnErrorSampleRate,
    replaysSessionSampleRate,
} from './integrations/replay';

const SentryConfig = (isActivated: boolean, hasConsent = false) => {
    const isSentryActive = isActivated && hasConsent;

    Console.info(
        `Sentry is ${
            isSentryActive ? 'activated' : 'deactivated'
        } (Feature Flag: ${isActivated}, Consent: ${hasConsent})`
    );

    const iterableTags = Object.entries(collectTagData);
    const integrations = () => {
        if (isActivated && hasConsent) {
            return [browserTracing, browserProfiling, replay];
        }
        return [];
    };

    iterableTags.forEach(([key, value]) => {
        Sentry.setTag(`${key}`, value);
    });

    return Sentry.init({
        dsn,
        integrations,
        enabled: isSentryActive,
        sendClientReports: hasConsent,
        enableTracing: hasConsent,
        debug: logLevels.size > 0,
        ignoreErrors,
        tracesSampleRate,
        replaysSessionSampleRate,
        replaysOnErrorSampleRate,
        release: process.env.RELEASE_VERSION || getCurrentRelease(),
        beforeSend(event, hint) {
            Console.error(event);
            Console.warn(hint);
            return event;
        },
    });
};

export default SentryConfig;
